// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_dw-j";
export var fulfillmentFormRail = "_dw-i";
export var headerTitleRow = "_dw-l";
export var orderDetailsWrapper = "_dw-g";
export var orderLinkTrigger = "_dw-2";
export var paymentInformationGrid = "_dw-q";
export var paymentSummaryColumn = "_dw-r";
export var phoneShipmentPickerButton = "_dw-e";
export var phoneShipmentPickerButtonContent = "_dw-f";
export var phoneShipmentPickerButtonWrapper = "_dw-d";
export var phoneShipmentPickerTrigger = "_dw-c";
export var shipmentContainer = "_dw-k";
export var shipmentDetailsMainPane = "_dw-h";
export var shipmentNavigationCard = "_dw-a";
export var shipmentNavigationEdgeTrigger = "_dw-6";
export var shipmentNavigationRail = "_dw-3";
export var shipmentNavigationRailEnter = "_dw-5";
export var shipmentNavigationRailHeader = "_dw-9";
export var shipmentNavigationRailOverlay = "_dw-4";
export var shipmentNavigationScrim = "_dw-7";
export var shipmentSummaryFact = "_dw-n";
export var shipmentSummaryGrid = "_dw-m";
export var shipmentSummaryMetadataRow = "_dw-o";
export var shipmentSummaryTags = "_dw-p";
export var shipmentWorkspace = "_dw-0";
export var shipmentWorkspaceBodyTablet = "_dw-8";
export var shipmentWorkspaceContent = "_dw-b";
export var shipmentWorkspaceHeader = "_dw-1";